import {
  // members
  LOAD_MEMBERS_LIST,
  SET_MEMBERS,
  START_SEND_INVITATIONS,
  END_SEND_INVITATIONS,
  SET_INVITATION_DETAILS,
  LOAD_INVITATIONS,
  SET_INVITATIONS,
  ADD_INVITATION,
  RESET_TEAM_STATE,
  ADD_USER_TO_REMOVE,
  CLEAN_USER_TO_REMOVE,
  SET_CURRENT_TEAM,
  UPDATE_MEMBER,
  REMOVE_USER_FROM_TEAM,
  REMOVE_INVITATION,
  SET_INVENTORY_CHART,
  SET_NEW_SUBTEAM_FOR_MEMBER,
  SET_MEMBERS_PAGINATION_COUNT,
  SET_INVITATION_PAGINATION_COUNT,
  SET_TEAM_AVAILABLE_ORDERS
} from '@/state/mutationTypes'
import getTeamStoreDefaultState from '@/state/teamStore/teamStoreDefaultState'

export default {
  [LOAD_MEMBERS_LIST](state, payload) {
    state.loadMembers = payload
  },

  [SET_MEMBERS](state, resultingMembers) {
    state.currentMembersList = resultingMembers
  },
  [START_SEND_INVITATIONS](state) {
    state.sendingInvitations = true
  },
  [END_SEND_INVITATIONS](state) {
    state.sendingInvitations = false
  },
  [SET_INVITATION_DETAILS](state, payload) {
    state.individualInvitation = payload
  },
  [LOAD_INVITATIONS](state, payload) {
    state.loadInvitations = payload
  },
  [SET_INVITATIONS](state, invitations) {
    state.currentInvitationsList = invitations
  },
  [ADD_INVITATION](state, invitations) {
    state.currentInvitationsList = [
      ...state.currentInvitationsList,
      ...invitations
    ]
  },
  [REMOVE_INVITATION](state, token) {
    let index = state.currentInvitationsList.findIndex(
      invitation => invitation.token === token
    )
    state.currentInvitationsList.splice(index, 1)
  },
  [ADD_USER_TO_REMOVE](state, payload) {
    let index = state.usersToRemove.findIndex(user => user.id === payload.id)

    if (index >= 0) {
      state.usersToRemove = state.usersToRemove.filter(
        user => user.id !== payload.id
      )
    } else {
      state.usersToRemove = [
        ...state.usersToRemove,
        { id: payload.id, name: payload.name }
      ]
    }
  },
  [CLEAN_USER_TO_REMOVE](state) {
    state.usersToRemove = []
  },
  [SET_CURRENT_TEAM](state, payload) {
    state.team = { ...payload }
  },
  [SET_TEAM_AVAILABLE_ORDERS](state, payload) {
    state.team.availableAdditionalOrders = payload
  },
  [UPDATE_MEMBER](state, payload) {
    let memberIndex = state.currentMembersList.findIndex(
      member => parseInt(member.id) === parseInt(payload.id)
    )

    let newMembersList = state.currentMembersList.filter(
      member => parseInt(member.id) !== parseInt(payload.id)
    )

    newMembersList.splice(memberIndex, 0, payload)

    state.currentMembersList = [...newMembersList]
  },
  [REMOVE_USER_FROM_TEAM](state, payload) {
    let currentMembersList = state.currentMembersList.filter(
      currentUser => parseInt(currentUser.id) !== payload
    )
    state.currentMembersList = [...currentMembersList]
  },
  [SET_INVENTORY_CHART](state, payload) {
    state.teamInventoryData = payload
  },
  [SET_NEW_SUBTEAM_FOR_MEMBER](state, payload) {
    let { currentMembersList } = state
    let memberIndex = currentMembersList.findIndex(
      member => parseInt(member.id) == parseInt(payload.userId)
    )
    if (memberIndex >= 0) {
      currentMembersList[memberIndex].subteam.id = parseInt(payload.id)
      currentMembersList[memberIndex].subteam.name = payload.name
    }

    state.currentMembersList = [...currentMembersList]
  },
  [RESET_TEAM_STATE](state) {
    Object.assign(state, getTeamStoreDefaultState())
  },
  [SET_MEMBERS_PAGINATION_COUNT](state, payload) {
    state.totalCount = payload
  },
  [SET_INVITATION_PAGINATION_COUNT](state, payload) {
    state.invitationPageCount = payload
  }
}
